import { render, staticRenderFns } from "./CreateDeliveryAddressForm.vue?vue&type=template&id=0b64c0a0"
import script from "./CreateDeliveryAddressForm.vue?vue&type=script&lang=js"
export * from "./CreateDeliveryAddressForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports